import React from "react";
import { motion } from "framer-motion";
import { BookOpenIcon, GiftIcon, ShieldCheckIcon, LockIcon, ZapIcon } from "lucide-react";
import { CountdownOffer } from "./CountdownOffer";
import { CHECKOUT_URL, OLD_PRICE, PRICE } from "../data/constants";
const INCLUDES = [{
  icon: BookOpenIcon,
  count: "6",
  label: "Tomos PDF"
}, {
  icon: GiftIcon,
  count: "6",
  label: "Bonos gratis"
}, {
  icon: ZapIcon,
  count: "∞",
  label: "Acceso inmediato"
}];
export function Offer() {
  return <section id="oferta" className="w-full bg-cream px-5 py-12" data-id="element-107" data-mp="p0jvl0kuc3fi">
      <div className="mx-auto max-w-md" data-id="element-108" data-mp="13x15rohanc0h">
        <p className="text-center text-xs font-bold uppercase tracking-[0.14em] text-gold" data-id="element-109" data-mp="13y2gfruedwho">
          Oferta especial de hoy
        </p>
        <h2 className="mt-1 text-center font-serif text-[28px] font-bold leading-tight text-deep-green" data-id="element-110" data-mp="z00zpdkg299d">
          Llevate el Kit Completo
        </h2>
        <p className="mt-1 text-center text-sm text-ink/70" data-id="element-111" data-mp="2adwcifnvm5xf">
          Ciudadanía Italiana Resuelta
        </p>

        <div className="mt-5 overflow-hidden rounded-3xl border border-gold/40 bg-beige shadow-lg" data-id="element-112" data-mp="pj5uqoeuwie0">
          <div className="border-b border-gold/25 bg-italian-green px-5 py-3 text-center text-cream" data-id="element-113" data-mp="ui0kkab8r77m">
            <p className="text-sm font-bold" data-id="element-114" data-mp="zjpwds6afowr">Esto es lo que te llevás hoy</p>
          </div>

          <div className="grid grid-cols-3 divide-x divide-sand bg-cream" data-id="element-115" data-mp="13iynsqduvap5">
            {INCLUDES.map(item => <div key={item.label} className="flex flex-col items-center px-2 py-4 text-center" data-id="element-116" data-mp="6vamtl5xdyst">
                <item.icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-117" data-mp="btc17ssep9xy" />
                <span className="mt-1 font-serif text-2xl font-bold text-deep-green" data-id="element-118" data-mp="ftcrcaovb9ku">
                  {item.count}
                </span>
                <span className="text-[10px] font-semibold leading-tight text-ink/65" data-id="element-119" data-mp="kn8ojaxb4sey">
                  {item.label}
                </span>
              </div>)}
          </div>

          <div className="px-4 pt-4" data-id="element-120" data-mp="3o8efdnkwf3fu">
            <CountdownOffer data-id="element-121" data-mp="vfh6aca5d1lg" />
          </div>

          <div className="px-5 pb-5 pt-4 text-center" data-id="element-122" data-mp="ve60y811zls8">
            <div className="flex items-end justify-center gap-2" data-id="element-123" data-mp="qh5vnzc12n26">
              <span className="mb-1 text-sm text-ink/45 line-through" data-id="element-124" data-mp="qejlrt1nzvgs">{OLD_PRICE}</span>
              <span className="font-serif text-4xl font-bold leading-none text-deep-green" data-id="element-125" data-mp="154qvnkdlw65v">
                {PRICE}
              </span>
            </div>
            <p className="mt-1 text-xs text-ink/60" data-id="element-126" data-mp="cg37nh1h32om">Pago único · Sin suscripciones</p>

            <motion.a href={CHECKOUT_URL} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-italian-green px-6 py-4 text-base font-bold text-cream shadow-lg shadow-italian-green/25 transition-colors hover:bg-deep-green" data-id="element-127" data-mp="7ibg4o4qpiky">
              <LockIcon className="h-5 w-5" aria-hidden="true" data-id="element-128" data-mp="1wyknuh7gynhw" />
              Aprende a gestionar tu ciudadanía
            </motion.a>

            <p className="mt-3 flex items-center justify-center gap-1.5 text-xs text-ink/60" data-id="element-129" data-mp="20ee0zf7tinus">
              <ShieldCheckIcon className="h-4 w-4 text-italian-green" aria-hidden="true" data-id="element-130" data-mp="25e9x6sa9xazs" />
              Compra segura · Acceso inmediato
            </p>
          </div>
        </div>
      </div>
    </section>;
}